function storageAvailable(type) {
	let stor;
	try {
		stor = window[type];
		const x = '__storage_test__';
		stor.setItem(x, x);
		stor.removeItem(x);
		return true;
	}
	catch (e) {
		return e instanceof DOMException && (
			// everything except Firefox
			e.code === 22 ||
			// Firefox
			e.code === 1014 ||
			// test name field too, because code might not be present
			// everything except Firefox
			e.name === 'QuotaExceededError' ||
			// Firefox
			e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
			// acknowledge QuotaExceededError only if there's something already stored
			(stor && stor.length !== 0);
	}
}

const _store = {};

function setItem(key, value) {
	_store[key] = value;
}
function getItem(key) {
	return _store[key];
}
function removeItem(key) {
	delete _store[key];
}

// setup memorystorage
const pageStorage = {
	setItem,
	getItem,
	removeItem
}

export function getStorage(level = '') {
	let storage = pageStorage;
	switch (level) {
		case 'persist':
			// setup localstorage, fallback to sessionstorage if not available, and to memorystorage as a last resort
			storage = storageAvailable("localStorage") ? window.localStorage : storageAvailable("sessionStorage") ? window.sessionStorage : pageStorage;
			break;
		case 'session':
			// setup sessionstorage, fallback to memorystorage if not available
			storage = storageAvailable("sessionStorage") ? window.sessionStorage : pageStorage;
			break;
		default:
			break;
	}
	return {
		storeKeyValue: (key, value) => {
			if (!key || typeof key !== 'string' || !value) {
				return;
			}

			if (typeof value === 'string') {
				storage.setItem(key, value)
			  } else {
				storage.setItem(key, JSON.stringify(value))
			  }
			return true;
		},
		getStoredValue: (key) => {
			if (!key || typeof key !== 'string') {
				return;
			}

			const value = storage.getItem(key)
			if (!value) return

			try {
			  // Returns an object if stored value is JSON
			  return JSON.parse(value);
			} catch (error) {
			  // Returns plain string if stored value is not JSON
			  return value;
			}
		},
		removeStoredValue: (key) => {
			if (!key || typeof key !== 'string') {
				return;
			}
			return storage.removeItem(key);
		}
	};
}
